var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBE7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 19.375H17.5C17.3342 19.375 17.1753 19.3092 17.0581 19.1919C16.9408 19.0747 16.875 18.9158 16.875 18.75V15.625C16.875 14.6304 17.2701 13.6766 17.9733 12.9733C18.6766 12.2701 19.6304 11.875 20.625 11.875C21.6196 11.875 22.5734 12.2701 23.2767 12.9733C23.9799 13.6766 24.375 14.6304 24.375 15.625V18.75C24.375 18.9158 24.3092 19.0747 24.1919 19.1919C24.0747 19.3092 23.9158 19.375 23.75 19.375ZM18.125 18.125H23.125V15.625C23.125 14.962 22.8616 14.3261 22.3928 13.8572C21.9239 13.3884 21.288 13.125 20.625 13.125C19.962 13.125 19.3261 13.3884 18.8572 13.8572C18.3884 14.3261 18.125 14.962 18.125 15.625V18.125Z",
    fill: "#523FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.125H17.5C16.6715 18.126 15.8772 18.4556 15.2914 19.0414C14.7056 19.6272 14.376 20.4215 14.375 21.25V25C14.376 25.8285 14.7056 26.6228 15.2914 27.2086C15.8772 27.7944 16.6715 28.124 17.5 28.125H23.75C24.5785 28.124 25.3728 27.7944 25.9586 27.2086C26.5444 26.6228 26.874 25.8285 26.875 25V21.25C26.874 20.4215 26.5444 19.6272 25.9586 19.0414C25.3728 18.4556 24.5785 18.126 23.75 18.125ZM21.25 22.9519V23.75C21.25 23.9158 21.1842 24.0747 21.0669 24.1919C20.9497 24.3092 20.7908 24.375 20.625 24.375C20.4592 24.375 20.3003 24.3092 20.1831 24.1919C20.0658 24.0747 20 23.9158 20 23.75V22.9519C19.7617 22.8143 19.5755 22.6019 19.4702 22.3477C19.3648 22.0935 19.3464 21.8116 19.4176 21.5458C19.4888 21.28 19.6457 21.0452 19.864 20.8777C20.0824 20.7101 20.3498 20.6193 20.625 20.6193C20.9002 20.6193 21.1676 20.7101 21.386 20.8777C21.6043 21.0452 21.7612 21.28 21.8324 21.5458C21.9036 21.8116 21.8852 22.0935 21.7798 22.3477C21.6745 22.6019 21.4883 22.8143 21.25 22.9519Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.f73ec4d3ae10536c1876c31004944b54.svg";
export { ForwardRef as ReactComponent };